<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Nova Natureza
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="financial-natures-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="financial-natures-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import FinancialNatureService from "@/services/financial-nature-service"
  import FormModal from "./form-modal"
  import { gridPage, onlyFinancial } from "@/mixins"

  export default {    

    name: "FinancialNaturesPage",

    mixins: [gridPage, onlyFinancial],

    data() {
      return {        
        title: "Naturezas Financeiras",
        service: new FinancialNatureService(),
        attributes: ["id", "description", "type"],
        fields: [          
          { prop: "description", label: "Descrição" },
          { prop: "type", label: "Tipo", render: this.renderType },
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      renderType(nature) {

        const typeList = FinancialNatureService.TYPE_ICONS

        return `<i class="${typeList[nature.type].icon} m-r-10"></i> ${typeList[nature.type].description}`
      },

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      },
    },
  }

</script>
